import React from "react";
import { Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { SmsRegCodeForm } from "../../Forms/SmsReg/SmsReg";
import { useModalNavigation } from "../../hooks/useModalNavigation";

interface CodeModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const CodeModal: React.FC<CodeModalProps> = ({ isOpen, setIsOpen, onClose }) => {
  const { handleRegSuccess, handleError } = useModalNavigation();

  return (
    <Modal
      title={ModalTexts.changePass.confirmMessage.TITLE}
      subTitle={ModalTexts.changePass.confirmMessage.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={onClose}
      mobileContentSize="full-screen-page-header"
    >
      <SmsRegCodeForm handleSubmitForm={handleRegSuccess} handleErrorForm={handleError} />
    </Modal>
  );
};

